require('./angular-aria');
module.exports = 'ngAria';



/** WEBPACK FOOTER **
 ** ./~/angular-aria/index.js
 **/